import { render, staticRenderFns } from "./ztsz-zxsj2.vue?vue&type=template&id=57fa29dc&"
import script from "./ztsz-zxsj2.vue?vue&type=script&lang=js&"
export * from "./ztsz-zxsj2.vue?vue&type=script&lang=js&"
import style0 from "./ztsz-zxsj2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports